export default __webpack_public_path__ + "static/media/img-0147-india-full-face.4eaa41c2.png";